import { Component, Input, OnChanges } from "@angular/core";
import { GroupNodeTag } from "../../canvas/model/graph-model";
import { Linqset, NODE_SUPERTYPE, NODE_TYPE } from "../../common/linqset-model";
import { ACTION_TYPE, Organisation } from "../../common/organisation";
import { INSIGHT_VALUE_TYPE, InsightCard } from "../../ui-components/insight-cards/insight-cards.component";
import { TagsService } from "../../organisation/tags/tags-service";

// the figures for the nodes inside a group, rather than the whole model
@Component({
    selector: 'app-group-properties',
    templateUrl: './group-properties.html',
    styleUrls: ['./group-properties.css'],
    standalone: false
})
export class GroupPropertiesComponent implements OnChanges {
    @Input() organisation:Organisation
    @Input() group: GroupNodeTag
    @Input() linqset:Linqset
    @Input() organisationLinqset:Linqset

    cards:InsightCard[] = []
    tagStyle:string

    constructor(private tagsService:TagsService) {}

    ngOnChanges(): void {
        this.cards = this.group ? this.createCards() : []
        this.tagStyle = this.group?.tag ? this.tagsService.getColourStyleForTag(this.group.tag) : undefined
    }

    private createCards():InsightCard[] {
        const insights = this.group.insights
        if (!insights) return []

        const superType = (st:NODE_SUPERTYPE) => insights.superTypes?.[st]
        const actions = superType(NODE_SUPERTYPE.ACTION)
        const cost = [NODE_SUPERTYPE.ROLE, NODE_SUPERTYPE.PEOPLE, NODE_SUPERTYPE.SYSTEM, NODE_SUPERTYPE.INFRASTRUCTURE]
            .reduce((total, st) => total + (superType(st)?.allocatedCost || 0), 0)
        const automated = insights.actionTypes?.[ACTION_TYPE.AUTOMATED]?.number || 0

        const cards = [
            new InsightCard("Actions", NODE_TYPE.ACTION, 'Actions in the group', null, actions?.number || 0),
            new InsightCard("Hours", NODE_TYPE.ACTION, 'Hours per annum for the actions in the group', null, actions?.hours || 0),
            new InsightCard("Cost", NODE_TYPE.ROLE, 'Cost of the people, roles, systems and infrastructure doing the work in the group', null, cost, null, INSIGHT_VALUE_TYPE.CURRENCY),
        ]
        if (actions?.number) cards.push(new InsightCard("Automated", NODE_TYPE.SYSTEM, 'Share of the actions performed by a system alone', `${Math.round(100 * automated / actions.number)}%`))
        if (insights.allocatedCarbonByScope?.total) cards.push(new InsightCard("Carbon", NODE_TYPE.INFRASTRUCTURE, 'Carbon emissions (kg CO₂e) for the group', null, insights.allocatedCarbonByScope.total))
        if (insights.outputRevenue) cards.push(new InsightCard("Revenue", NODE_TYPE.INFORMATION, 'Revenue from the outputs in the group', null, insights.outputRevenue, null, INSIGHT_VALUE_TYPE.CURRENCY))
        if (insights.outputValue) cards.push(new InsightCard("Value", NODE_TYPE.INFORMATION, 'Value of the outputs in the group', null, insights.outputValue))
        return cards
    }
}
